export default __webpack_public_path__ + "static/media/BuickFavicon.7f1b87ff.ico";